import { FeedType, MainPageType } from './models';
import { TFunction } from '@wix/yoshi-flow-editor';

type HeaderNavigationItem = {
  id: FeedType;
  title: string;
  isVisible: boolean;
  isActive: boolean;
  feedType: FeedType | null;
};

type GenerateHeaderNavigationItemsDto = {
  t: TFunction;
  mainPageType: MainPageType;
  activeFeedType: string;
  isCategoriesPageVisible: boolean;
};

export const generateHeaderNavigationItems = ({
  t,
  mainPageType,
  isCategoriesPageVisible,
  activeFeedType,
}: GenerateHeaderNavigationItemsDto): HeaderNavigationItem[] => {
  const isMainPageCategories = mainPageType === MainPageType.Categories;

  const categoriesItem: HeaderNavigationItem = {
    id: FeedType.Categories,
    title: t('tabs.categories'),
    isVisible: isCategoriesPageVisible,
    isActive: activeFeedType === FeedType.Categories,
    feedType: isMainPageCategories ? null : FeedType.Categories,
  };

  const postsItem: HeaderNavigationItem = {
    id: FeedType.Posts,
    title: t('tabs.posts'),
    isVisible: true,
    isActive: activeFeedType === FeedType.Posts,
    feedType: isMainPageCategories ? FeedType.Posts : null,
  };

  const myPostsItem: HeaderNavigationItem = {
    id: FeedType.MyPosts,
    title: t('tabs.my-posts'),
    isVisible: true,
    isActive: activeFeedType === FeedType.MyPosts,
    feedType: FeedType.MyPosts,
  };

  return [
    isMainPageCategories ? categoriesItem : postsItem,
    isMainPageCategories ? postsItem : categoriesItem,
    myPostsItem,
  ].filter(({ isVisible }) => isVisible);
};
